import React from 'react';
import moment from 'moment';
import { Link } from '@this/shared/ui/navigations/link';
import type CreditBalanceHistory from '@this/domain/credit_balance_history';

interface Props {
  records: CreditBalanceHistory[];
}

export const PlanCreditHistoryTable = ({ records }: Props) => {
  const styles = getStyles();
  return (
    <table style={styles.table}>
      <tbody>
        <tr>
          <th style={styles.th}>日時</th>
          <th style={styles.th}>内容</th>
          <th style={styles.th}>有効期限</th>
          <th style={styles.thRight}>請求額</th>
          <th style={styles.thRight}>お支払額</th>
          <th style={styles.thRight}>クレジットポイント残高</th>
          <th style={styles.thRight}>領収書</th>
        </tr>
        {records.map(r => (
          <tr key={r.id}>
            <td style={styles.td}>{r.date.format('YYYY/MM/DD hh:mm')}</td>
            <td style={styles.td}>{r.description}</td>
            <td style={styles.td}>{r.expireAt?.format('YYYY/MM/DD')}</td>
            <td style={styles.tdRight}>
              {typeof r.billedAmount === 'number' ? utils.formatPrice(r.billedAmount) : ''}
            </td>
            <td style={styles.tdRight}>
              {typeof r.paidAmount === 'number' ? utils.formatPrice(r.paidAmount) : ''}
            </td>
            <td style={styles.tdRight}>{utils.formatPrice(r.balance)}</td>
            <td style={styles.tdRight}>
              {r.paidAmount && moment(r.date.format('YYYY-MM-DD')).isAfter(moment('2023-10-01')) && (
                <Link href={`/aiexpense/organization/payment_receipts/${r.id}_qualified.pdf`} isExternal>
                  PDF
                </Link>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

function getStyles() {
  const thBase: React.CSSProperties = { fontWeight: 'normal', color: '#7d7d7d', padding: '4px' };
  const tdBase: React.CSSProperties = { padding: '4px' };
  return {
    table: { margin: 0, tableLayout: 'auto', width: 'auto', fontSize: '12px' } as React.CSSProperties,
    th: thBase,
    thRight: { ...thBase, textAlign: 'right' } as React.CSSProperties,
    td: tdBase,
    tdRight: { ...tdBase, textAlign: 'right', minWidth: '100px' } as React.CSSProperties
  } as const;
}
